import Button from "@/components/shared/Button/Button";
import star from "@/images/star.png";
import AppState, { POPUPS } from "@/js/AppState";
import Minigame from "@/js/Minigames/Minigame";
import Minigames from "@/js/Minigames/Minigames";
import SequenceScenario from "@/js/SequenceScenario";
import { FaLock } from "react-icons/fa6";
import PopupsManager from "react-sdk/PopupsManager";
import Texts from "react-sdk/Texts";

// NOTE : on stocke des components de boutons de popup notif comme ils sont dynamiques, on les passe en param, mais parfois c'est depuis un .js qui connait pas le jsx, donc on les stocke ici

/**
 *
 * @param {{mg: Minigame}} param0
 * @returns
 */
export const PopupNotifStartMinigameBtns = ({mg}) => {

  return (
  <div className={"PopupNotifStartMinigameBtns_list"}>
      <div className={"PopupNotifStartMinigameBtns"}>
        <Button
          className={"play_btn"}
          onClick={() => {
            PopupsManager.close(POPUPS.NOTIF)
            if(mg.type !== "placeholder")
              Minigames.launch(mg)
            else Minigames.endMg();
          }} >
          { Texts.get("popup-notif-minigame-btn-play") }
        </Button>
      </div>
  </div>
  )
}

export const PopupMGReglesBtn = () => {

  const onclick= () => {
    PopupsManager.close(POPUPS.NOTIF)
  }

  return (
    <Button onClick={onclick} >{Texts.get("popup-notif-minigame-ftue-button")}</Button>
  )
}


export const PopupNotifChapterEndBtns = () => {
  return (
    <Button onClick={() => {

      // ici on relance la sequence principale
      SequenceScenario.playSequence("MainSequence", "root")
      PopupsManager.close(POPUPS.NOTIF)

    }} >{Texts.get("popup-chapter-ended-btn")}</Button>
  )
}


export const PopupNotifNewCollecteBtnsEstim = ({collecte}) => {
  const handleClick = () => {
    PopupsManager.open(POPUPS.COLLECTE, collecte)
    PopupsManager.close(POPUPS.NOTIF)
  }

  return (
    <div>
      <Button onClick={handleClick} >{Texts.get("popup-notif-newcollecte-referent-btn")}</Button>
    </div>
  )
}

export const PopupNotifNewCollecteBtnsOK = () => {

  const handleClick = () => {
    PopupsManager.close(POPUPS.NOTIF)
  }

  return (
    <div>
      <Button onClick={handleClick} >OK</Button>
    </div>
  )
}


export const PopupNotifNewCollecteBtns = ({isReferent, collecte}) => {

  const handleClick = () => {
    PopupsManager.open(POPUPS.COLLECTE, collecte)
    PopupsManager.close(POPUPS.NOTIF)
  }

  return (
    <div>
      {isReferent && <Button onClick={handleClick} >{Texts.get("popup-notif-newcollecte-referent-btn")}</Button>}
      {!isReferent && <Button onClick={handleClick} >{Texts.get("popup-notif-newcollecte-player-btn")}</Button>}
    </div>

  )
}


export const PopupNotifImReferentBtn = () => {
  return (
    <Button onClick={() => PopupsManager.close(POPUPS.NOTIF)} >{Texts.get("popup-notif-im-referent-btn")}</Button>
  )
}

export const PopupNotifOtherSessionsBtn = ({handleClick}) => {

  return (
    <Button onClick={handleClick}>{Texts.get("popup-notif-session-other-button")}</Button>
  )
}

export const PopupNotifSessionClosedBtn = () => {

  function handleClick() {
    window.close()
  }
  return (
    <Button onClick={handleClick}>Fermer la fenêtre</Button>
  )
}